import { render } from "./spreakerForm.vue?vue&type=template&id=555d66d8"
import script from "./spreakerForm.vue?vue&type=script&lang=js"
export * from "./spreakerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__